import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Card, CardBody, CardTitle } from "reactstrap";
import { Panel } from '../../components/panel/panel.jsx';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {getMuiTheme, tableOptions} from '../../util/MuiTableTheme';

class ComplaintReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataComplaint: [],
      startDate: '',
      endDate: ''
    };
  };

  componentDidMount(){
    this.getDataComplaint();
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Komplain</li>
      </ol>
      <h1 className="page-header">Laporan Komplain</h1>
    </div>
  );

  getDataComplaint = () => {
    const { startDate, endDate } = this.state;
    const param = { params: { startDate, endDate }};
    Services.getComplaintList(param)
      .then(res => {
        // console.log('xxx res', res);
        this.setState({dataComplaint: res});
      })
      .catch(err => console.log(err))
  };

  renderComplaintTable = () => {
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "createDate",
        label: "Tanggal Laporan",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "createBy",
        label: "Pelapor",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "title",
        label: "Judul",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "sendTo",
        label: "Ditujukan",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "priority",
        label: "Prioritas",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "_id",
        label: "Aksi",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            
            return (
              <div className="with-btn text-nowrap">
                <Link 
                  to={{
                    pathname: '/reporting/complaint-data-detail',
                    state: {
                      selectedData: this.state.dataComplaint.find(item => item._id === value)
                    }
                  }}
                >
                <button 
                  className="btn btn-sm btn-success width-70">Detail</button>
                </Link>
              </div>
            );
          }
        }
      }
    ];
      
    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Komplain"}
          data={this.state.dataComplaint}
          columns={columns}
          options={tableOptions}
        />
      </MuiThemeProvider>
    )
  };

  _renderDatePickerStart = () => (
    <DatePicker
      className="form-control"
      value={this.state.startDate}
      placeholderText="Click to select start Date"
      onChange={value => this.setState({ startDate: moment(value).format('DD-MM-YYYY') })}
      onCalendarClose={this.getDataComplaint}
    />
  );

  _renderDatePickerEnd = () => (
    <DatePicker
      className="form-control"
      value={this.state.endDate}
      placeholderText="Click to select end Date"
      onChange={value => this.setState({ endDate: moment(value).format('DD-MM-YYYY') })}
      onCalendarClose={this.getDataComplaint}
    />
  );
  
  renderFilterDateSection = () => (
    <Card
      className="border-0 card-inverse text-white bg-dark"
      style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
    >
      <CardBody>
        <CardTitle tag="h4">Filter</CardTitle>
        <div className="row">
          <div className="ml-2">
            <div className="w-100 customDatePickerWidth">
              <label className="mr-2">Tanggal Mulai</label>
              {this._renderDatePickerStart()}
            </div>
          </div>
          <div className="ml-2">
            <div className="w-100 customDatePickerWidth">
              <label className="mr-2">Tanggal Akhir</label>
              {this._renderDatePickerEnd()}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );

  render(){
    return(
      <div>
        {this.renderBreadcrumb()}
        <Panel>
          {this.renderFilterDateSection()}
          {this.renderComplaintTable()}
        </Panel>
      </div>
    )
  }
}

export default withNotification(ComplaintReport);